//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'MdmModal',
  props: {
    showModal: {
      type: Boolean,
      required: true
    },
    withCloseLabel: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      lastFocus: null
    };
  },

  mounted() {
    if (this.showModal === true) {
      this.disableWindowScroll();
    }
  },

  destroyed() {
    this.enableWindowScroll();
  },

  updated() {
    if (this.showModal) {
      // disable scroll when modal is open
      this.disableWindowScroll(); // save last focused element and focus on the modal

      this.lastFocus = document.activeElement;
    } else if (this.lastFocus) {
      this.enableWindowScroll(); // focus on last focused element

      this.lastFocus.focus();
    }
  },

  methods: {
    close() {
      this.$emit('onclosemodal');
      this.enableWindowScroll();
    },

    handleFocus(evt) {
      // keep focus inside the modal (focus trap for a11y)
      if (!this.$el.contains(evt.relatedTarget)) {
        this.$el.focus();
      }
    }

  }
};